import { Link } from "react-router-dom";
import "./Rodape.scss";
import { desktopImages } from "../../images";
import BusinessLogo from "../../assets/img/group-logo.svg";

const Rodape = () => {
  return (
    <div className="rodape">
      <div className="container">
        <Link to="/">
          <img
            src={BusinessLogo}
            className="BusinessLogo"
            alt="Logo Essentia Group"
          />
        </Link>
        <div className="marcas">
          <a href="/#nossas-marcas">Nossas marcas</a>
          <Link to="/qualidade">Qualidade</Link>
          <Link to="/essentiaexperience">Essentia Experience</Link>
          <Link to="/carreiras">Trabalhe conosco</Link>
          <Link to="/contatos">Contatos</Link>
        </div>
        <div className="cep">
          <p>Rua João Lourenço, 530, Vila Nova Conceição</p>
          <p>São Paulo, SP | CEP: 04.508-030</p>
        </div>
        <div className="logos">
          <a href="https://essentia.com.br/" target="_blank" rel="noreferrer">
            <img
              src={desktopImages.EssentiaPharma}
              alt="Logo Essentia Pharma"
            />
          </a>
          <a
            href="https://www.essentialnutrition.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={desktopImages.EssentialNutrition}
              alt="Logo Essentia Pharma"
            />
          </a>
          <a
            href="https://www.noorskin.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={desktopImages.Noorskin} alt="Logo Essentia Pharma" />
          </a>
          <a href="https://begenerous.com.br/" target="_blank" rel="noreferrer">
            <img src={desktopImages.BeGenerous} alt="Logo Essentia Pharma" />
          </a>
          <a
            href="https://easy-health.app/landing-page/index.html"
            target="_blank"
            rel="noreferrer"
          >
            <img src={desktopImages.EasyHealth} alt="Logo Essentia Pharma" />
          </a>
          <a
            href="https://essentiaexperience.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={desktopImages.ExperienceP} alt="Logo Essentia Pharma" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Rodape;
